import React from 'react';
import { ListMenuPropTypes, ListMenuDefaultProps } from '../propTypes';
import { Container, LinkList, Link, } from './styled';
function LinkListMenu({ icon, to, title, isActive, linkList, activeLink, }) {
    return (React.createElement(Container, { isActive: isActive }, isActive && (React.createElement(LinkList, null, linkList.map((link) => (React.createElement(Link, { key: `${link.to.pathname || link.to}-${link.value}`, to: link.to, isActive: activeLink && link.to === activeLink.to }, link.value)))))));
}
LinkListMenu.propTypes = ListMenuPropTypes;
LinkListMenu.defaultProps = ListMenuDefaultProps;
export default LinkListMenu;
